import { render, staticRenderFns } from "./GestionProduits.vue?vue&type=template&id=07981058&scoped=true&"
import script from "./GestionProduits.vue?vue&type=script&lang=js&"
export * from "./GestionProduits.vue?vue&type=script&lang=js&"
import style0 from "./GestionProduits.vue?vue&type=style&index=0&id=07981058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07981058",
  null
  
)

export default component.exports